import { useUserInfoStore, type CurrentCurrency } from '../stores/use-user-info'
import { useConfigWatchEffect } from './use-config-watch-effect'

export const useChangeCurrency = (
  fn: (data?: { oldCurrentToCurrency: CurrentCurrency<keyof ApiResponse.OtcCoinRate>; newCurrentToCurrency: CurrentCurrency<keyof ApiResponse.OtcCoinRate> }) => void,
  options: { immediate?: boolean } = { immediate: false },
) => {
  const userInfoStore = useUserInfoStore()

  const autoRun = async () => {
    return new Promise<void>((resolve) => {
      watch(
        () => userInfoStore.currentToCurrency,
        async (newCurrentToCurrency, oldCurrentToCurrency) => {
          fn({
            oldCurrentToCurrency: oldCurrentToCurrency as CurrentCurrency<keyof ApiResponse.OtcCoinRate>,
            newCurrentToCurrency: newCurrentToCurrency as CurrentCurrency<keyof ApiResponse.OtcCoinRate>,
          })
          resolve()
        },
        options,
      )
    })
  }

  onMounted(() => {
    useConfigWatchEffect(autoRun)
  })
}
